const LS_KEY = 'glyphicai-user-public-id'

/** 登录成功后由接口写入；未登录时为 null（禁止本地默认伪装身份） */
export function readStoredUserPublicId(): string | null {
  try {
    const v = localStorage.getItem(LS_KEY)?.trim()
    return v || null
  } catch {
    return null
  }
}

export function writeUserPublicId(id: string): void {
  try {
    localStorage.setItem(LS_KEY, id.trim())
  } catch {
    /* ignore */
  }
}
